// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module__container___3_j1F","star":"index-module__star___mNZ3-"};